import { faFlag } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IBoltTask } from "@bolt/core";
import { AsyncODataDropdownField } from "@ucl/library";
import React from "react";
import { SOPComponent } from "../SOPComponent/SOPComponent";
import { SLAComponent } from "../SlaComponent/SlaComponent";
import { faSquare, faCheckSquare } from "@fortawesome/free-regular-svg-icons";
import { assigneeAsyncAutoCompleteConfig } from "../config/assigneeAsyncAutoComplete";

export interface TaskExecutionOverviewProps {
  task: IBoltTask;
  isReadOnly: boolean;
  apiBaseUrl: string;
  getAuthRequestHeader: () => Promise<Record<string, string> | undefined>;
  onTaskReassigned: (assigneeId: string) => void;
}
export const TaskExecutionOverview: React.FC<TaskExecutionOverviewProps> = (
  props
) => {

  return (
    <section className="bolt-task-execution-overview">
      <ul>
        <li className="bolt-task-execution-overview-task-execution-type">
          <span>Execution Type</span>
          <span>{props.task.taskExecutionTypeName}</span>
        </li>
        <li className="bolt-task-execution-overview-task-status">
          <span>Status</span>
          <span>{props.task.taskStatus_AsString}</span>
        </li>
        <li className="bolt-task-execution-overview-task-assignees">
          <span>Assignees</span>
          <span>
            {props.isReadOnly ? (
              <>{props.task.assigneeName}</>
            ) : (
              <AsyncODataDropdownField
                {...assigneeAsyncAutoCompleteConfig({
                  odataUrl: `${props.apiBaseUrl}/odata/bolttaskassigneeodata`,
                  getAuthRequestHeader: props.getAuthRequestHeader,
                })}
                label=""
                fieldKey="BoltTask__AssigneeId"
                fieldName="BoltTask__AssigneeId"
                value={props.task.assigneeId}
                hideSearchIcon
                onSubmit={(value) => {
                  const assignee = value as unknown as { value: string };
                  if (assignee?.value) {
                    props.onTaskReassigned(assignee.value);
                  }
                }}
              />
            )}
          </span>
        </li>
        <li
          className={`bolt-task-execution-overview-rush bolt-task-execution-overview-rush-${props.task.isRush ? "true" : "false"}`}
        >
          <span>Rush</span>
          <span>
            {props.task.isRush ? (
              <FontAwesomeIcon icon={faCheckSquare} />
            ) : (
              <FontAwesomeIcon icon={faSquare} />
            )}
          </span>
        </li>
        <li
          className={`bolt-task-execution-overview-priority bolt-task-execution-overview-priority-${props.task.taskPriority_AsString?.toLowerCase() || "normal"}`}
        >
          <span>Priority</span>
          <span>
            <FontAwesomeIcon icon={faFlag} /> {props.task.taskPriority_AsString}
          </span>
        </li>
        <li className="bolt-task-execution-overview-sla bolt-task-execution-overview-sla-past-due">
          <span>SLA</span>
          <span>
            <SLAComponent
              showLabel={false}
              readOnly={true}
              value={{
                sla: props.task.sla,
                slaUnit: props.task.slaUnit,
              }}
            />
          </span>
        </li>
        <li className="bolt-task-execution-overview-task-sop">
          <span>SOP</span>
          <span>
            <SOPComponent
              showLabel={false}
              readOnly={true}
              value={{
                sop: props.task.taskTemplateSOP,
                sop_AsList: props.task.taskTemplateSOP_AsList,
              }}
              showInvalidUrlWarning={false}
            />
          </span>
        </li>
      </ul>
    </section>
  );
};
